(ns pfo.staging.aark)

;; =============================================================================
;; AARK FIRST-PASS CLASSIFICATION ADAPTER (#2851 review UI / #2854 Stage 3)
;; =============================================================================
;;
;; The staff review UI (dashboard preview table + Unfiled workspace) shows AARK's
;; first-pass classification for each staged document: a suggested collection,
;; category, application date and free-text name, plus any caveat notes (e.g.
;; "collection uncertain"). That proposal is produced by #2854 Stage 3 and now
;; arrives on every staging-queue row as:
;;
;;   :classification_status   "pending" | "running" | "succeeded" | "failed" | "skipped"
;;   :classification_proposal {:category_id <int> :collection_ids [<int>...]
;;                             :main_collection_id <int> :custom_name <str>
;;                             :year <int> :quarter <int> :month <int> :day <int>
;;                             :notes [<str>...]}   ; any field may be absent; the
;;                                                  ; whole object is nil until
;;                                                  ; classification succeeds.
;;
;; `proposal-for` is the single seam every consumer goes through: it normalizes
;; that raw row into a stable CLJS shape. The proposal carries only IDs; the
;; backend adds resolved labels for the dashboard preview.
;;
;; Normalized shape returned by `proposal-for`:
;;   {:status               <string|nil>      ; classification_status
;;    :succeeded?           <bool>            ; status = "succeeded" AND a proposal exists
;;    :category-id          <int|nil>
;;    :collection-ids       [<int>...]        ; possibly empty
;;    :main-collection-id   <int|nil>
;;    :custom-name          <string|nil>
;;    :date                 {:year :quarter :month :day}  ; any may be nil
;;    :notes                [<string>...]      ; AARK caveats, possibly empty
;;    :proposal-collections [<document_collections-shaped entry>...]
;;                                            ; backend-resolved breadcrumbs for the
;;                                            ; dashboard preview; empty when no proposal
;;    :category-name        <string|nil>}     ; backend-resolved category name

(defn proposal-for
  "Return the normalized AARK classification proposal for a staging-queue ROW.
  Reads the real `:classification_proposal` / `:classification_status` the
  backend (#2854 Stage 3) attaches to each row. Returns a stable shape even when
  classification has not succeeded (proposal fields are then nil/empty)."
  [row]
  (let [status (some-> (:classification_status row) name)
        p      (:classification_proposal row)]
    {:status             status
     :succeeded?         (and (= status "succeeded") (some? p))
     :category-id        (:category_id p)
     :collection-ids     (vec (:collection_ids p))
     :main-collection-id (:main_collection_id p)
     :custom-name        (:custom_name p)
     :date               {:year    (:year p)
                          :quarter (:quarter p)
                          :month   (:month p)
                          :day     (:day p)}
     :notes              (vec (:notes p))
     :proposal-collections (vec (:proposal_collections row))
     :category-name      (:category_name row)}))

(defn notes-for
  "Convenience: just the AARK caveat note strings for ROW (possibly empty)."
  [row]
  (:notes (proposal-for row)))
